export default __webpack_public_path__ + "static/media/xiaoshouguanli.204b68fc.png";